import React from 'react'
import AuthPageLayout from '../../layout/auth_page_layout'
import TextField from '../../components/textfield'
import Button from '../../components/button'
import { useOnInputChange } from '../../hooks/useOnInputChange'
import { useNavigate } from 'react-router-dom'
import Typography from '../../components/typography'
import { AuthService } from '../../apilibrary'
import { trackUserSignUpClick } from '../../utils/analytics'

const SignupPage: React.FC = () => {
  const [email, onChangeEmail] = useOnInputChange('')
  const [password, onChangePassword] = useOnInputChange('')
  const [confirmPassword, onChangeConfirmPassword] = useOnInputChange('')
  const [disableButton, setDisableButton] = React.useState(false)
  const [error, setError] = React.useState<string>()
  const navigate = useNavigate()

  const handleClickSignup = async (): Promise<void> => {
    setError(undefined)
    try {
      setDisableButton(true)
      await AuthService.signup({
        email,
        password
      })
      await trackUserSignUpClick()
      navigate('/auth/confirmation?email=' + email)
    } catch (e) {
      console.log(e)
      if (e instanceof Error) {
        setError(e.message)
      } else {
        setError('Something went wrong')
      }
    } finally {
      setDisableButton(false)
    }
  }

  return (
    <AuthPageLayout title='Create Account'>
      {(Boolean(error)) && <Typography color={'error'}>{error}</Typography>}
      <TextField
        fullWidth
        gutterBottom
        value={email}
        onChange={onChangeEmail}
        label='Email'
      />
      <TextField
        fullWidth
        gutterBottom
        value={password}
        onChange={onChangePassword}
        label='Password'
        type='password'

        />
      <TextField
        fullWidth
        gutterBottom
        type='password'
        value={confirmPassword}
        onChange={onChangeConfirmPassword}
        label='Confirm Password'
      />
      {/* TODO: Add Terms and Conditions */}
      <Button
        sx={{
          marginTop: 4
        }}
        fullWidth
        disabled={disableButton}
        variant='contained'
        onClick={handleClickSignup}>
        Signup
      </Button>
    </AuthPageLayout>
  )
}

export default SignupPage
